import {IComponentController, IComponentOptions, IPromise} from "angular";
import {convertUserToUserGuiDto, UserGuiDto} from "../../../users/model/User";
import './single-employee-autocomplete.component.scss';

export class SingleEmployeeAutocompleteComponent<UserDto> implements IComponentController {

    public static instance: IComponentOptions = {
        template: require('./single-employee-autocomplete.component.html'),
        controller: [SingleEmployeeAutocompleteComponent],
        bindings: {
            'myPlaceholder': '@',
            'onSelectedEmployeeChange': '<',
            'selectedEmployee': '=',
            'fetchFunction': '<',
            'myDisabled': '<'
        },
    };

    private noCache: boolean = false;
    private selectedEmployee: UserDto;
    private searchText: string = '';
    private onSelectedEmployeeChange: (item: UserDto) => void;
    private fetchFunction: (searchText: string) => IPromise<UserDto[]>;

    constructor() {
    }

    querySearch = (searchText: string): IPromise<UserGuiDto[]> => {
        return this.fetchFunction(searchText).then((users) => convertUserToUserGuiDto(users));
    };

    private searchTextChange = (searchText: string) => {
        this.searchText = searchText;
    };

    private selectedItemChange = (item: UserDto) => {
        this.selectedEmployee = item;
        this.onSelectedEmployeeChange(item);
    };


}